import { checkAuth } from "@/common/utils";
import userRoute from "./user.route";
import dashboardRoute from "./dashboard.route";
import notificationRoute from "./notification.route";
import quoteRoute from "./quote.route";
import accountRoute from "./accounts.route";
import documentsRoute from "./documents.route";
import buildingsRoute from "./buildings.route";
import priceRoute from "./price.route";
import servicesRoute from "./services.route";
import { MainLayout } from "@/layouts";

const mainRoute = [
  {
    path: "/",
    element: <MainLayout />,
    loader: checkAuth,
    children: [
      ...dashboardRoute,
      ...notificationRoute,
      ...quoteRoute,
      ...userRoute,
      ...accountRoute,
      ...documentsRoute,
      ...buildingsRoute,
      ...priceRoute,
      ...servicesRoute,
    ],
  },
];
export default mainRoute;
